/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycChangeRequestWithItemsDto } from '../../models/kyc-change-request-with-items-dto';

export interface CreateWithItems$Params {
  processId: string;
      body: KycChangeRequestWithItemsDto
}

export function createWithItems(http: HttpClient, rootUrl: string, params: CreateWithItems$Params, context?: HttpContext): Observable<StrictHttpResponse<KycChangeRequestWithItemsDto>> {
  const rb = new RequestBuilder(rootUrl, createWithItems.PATH, 'post');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycChangeRequestWithItemsDto>;
    })
  );
}

createWithItems.PATH = '/kyc/processes/{processId}/change-requests';
